module.exports = __webpack_public_path__ + "assets/media/product-icon.7ef4678c.svg";